/**
 * 区分 personnelType（personnel.personnel_type）
 * 出典：要件書 5.2
 */
export const PERSONNEL_TYPE_VALUES = ['employee', 'partner'] as const;

export type PersonnelType = (typeof PERSONNEL_TYPE_VALUES)[number];

export const PERSONNEL_TYPE_LABELS: Readonly<Record<PersonnelType, string>> = {
  employee: '自社社員',
  partner: '協力会社',
};
